<template>
  <div class="map-container">
    <div id="map" :style="elementStyle" />
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
const defaultMapPosition = {
  center: { lng: -73.76, lat: 44.77 },
  zoom: 5
}
const defaultMapOptions = {
  ...defaultMapPosition,
  container: 'map',
  style: 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json',
  minZoom: 5,
  maxZoom: 17,
  attributionControl: false,
  hash: false
}
export default {
  name: 'GlMap',
  props: {
    /**
     * css styles to apply to map div
     */
    elementStyle: {
      type: Object,
      default: () => ({
        height: '100vh'
      })
    },
    /**
     * mapbox map constructor options
     * https://docs.mapbox.com/mapbox-gl-js/api/map/
     *
     */
    initMapOptions: {
      type: Object,
      default: () => defaultMapOptions
    },
    /**
     * initial position
     *  {
     *    center: { lng: Number, lat: Number },
     *    zoom: Number
     *  }
     *
     */
    initMapPosition: {
      type: Object,
      default: () => defaultMapPosition
    }
  },
  data() {
    return {
      loaded: false
    }
  },
  watch: {
    loaded(value) {
      this.$emit('loaded', value)
    }
  },
  created() {
    this.map = null
  },
  mounted() {
    const mapDefaultOptions = {
      ...defaultMapOptions,
      ...this.initMapOptions,
      ...this.initMapPosition
    }
    this.map = new mapboxgl.Map(mapDefaultOptions)
    this.map.on('load', () => {
      this.loaded = true
    })
  }
}
</script>

<style lang="scss" scoped>
#map {
  overflow: hidden;
}
</style>
